import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { bffApi } from "../../autogen/bff-api";
import "./departmentApiEnhancements";
import { refreshFrameworkAgreementsWhenRefused } from "./frameworkAgreementRefusal";
import "./evaluationApiEnhancements";
import "./participationRequestApiEnhancements";
import "./projectSummaryApiEnhancements";
import "./sourcingEventDryRunEnhancements";
import authStateReducer from "./reducers/authStateReducer";
import contractReducer from "./reducers/contractReducer";
import { productReducer } from "./reducers/productReducer";

export const store = configureStore({
  reducer: {
    [bffApi.reducerPath]: bffApi.reducer,
    authState: authStateReducer,
    contract: contractReducer,
    product: productReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ["meta.arg.user", "meta.baseQueryMeta.request", "meta.baseQueryMeta.response"],
      },
    }).concat(bffApi.middleware, refreshFrameworkAgreementsWhenRefused),
  devTools: true,
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
